/* SalonOnline REFILL theme JS */
(function(){
  "use strict";
  const S = window.SalonOnline || { freeShipping: 15000, refillTarget: 300, moneyFormat: "${{amount}}" };

  const money = cents => {
    const amount = (cents/100).toFixed(2);
    return (S.moneyFormat || "${{amount}}").replace(/\{\{\s*amount[^}]*\}\}/, amount).replace(/<[^>]+>/g, "");
  };

  /* ---------- toast ---------- */
  let toastTimer;
  window.toast = function(msg){
    const t = document.getElementById("toast");
    if(!t) return;
    t.textContent = msg; t.classList.add("on");
    clearTimeout(toastTimer);
    toastTimer = setTimeout(()=>t.classList.remove("on"), 2600);
  };

  /* ---------- marquees: duplicate tracks for a seamless -50% loop ---------- */
  document.querySelectorAll(".marquee-track").forEach(tr=>{ tr.innerHTML += tr.innerHTML; });

  /* ---------- REFILL bottles ---------- */
  function fillBottles(){
    document.querySelectorAll(".bliq[data-fill]").forEach(el=>{ el.style.height = el.dataset.fill + "%"; });
  }
  if("IntersectionObserver" in window){
    const io = new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting){ fillBottles(); } }), {threshold:.3});
    document.querySelectorAll(".bottle").forEach(b=>io.observe(b));
  }
  setTimeout(fillBottles, 500);

  /* ---------- cart drawer ---------- */
  const drawer = document.getElementById("CartDrawer");
  const scrim  = document.getElementById("CartScrim");
  function openDrawer(){ if(drawer){ drawer.classList.add("on"); scrim.classList.add("on"); } }
  function closeDrawer(){ if(drawer){ drawer.classList.remove("on"); scrim.classList.remove("on"); } }
  window.openCartDrawer = openDrawer;
  if(scrim) scrim.addEventListener("click", closeDrawer);
  document.addEventListener("keydown", e=>{ if(e.key==="Escape") closeDrawer(); });
  document.addEventListener("click", e=>{
    if(e.target.closest("[data-cart-open]")){ e.preventDefault(); openDrawer(); }
    if(e.target.closest("[data-cart-close]")) closeDrawer();
  });

  function renderCart(cart){
    const items = document.getElementById("CartItems");
    const countEl = document.getElementById("CartCount");
    if(countEl) countEl.textContent = cart.item_count;
    const totalEl = document.getElementById("CartTotal");
    if(totalEl) totalEl.textContent = money(cart.total_price);
    const shipFill = document.getElementById("ShipFill");
    const shipMsg  = document.getElementById("ShipMsg");
    if(shipFill && shipMsg){
      const pct = Math.min(100, cart.total_price / S.freeShipping * 100);
      shipFill.style.width = pct + "%";
      shipMsg.innerHTML = cart.total_price >= S.freeShipping
        ? "<b>Free shipping unlocked</b> — nice work"
        : "<b>" + money(S.freeShipping - cart.total_price) + "</b> away from free shipping";
    }
    const loopMsg = document.getElementById("CartRefillMsg");
    const loopRow = document.getElementById("CartRefillRow");
    if(loopMsg){
      const ml = Math.round(cart.total_price/100);
      loopMsg.textContent = "This order pours " + Math.min(S.refillTarget, ml) + "mL into your REFILL bottle" +
        (ml >= S.refillTarget ? " — that's a full bottle. Refill unlocked!" : "");
      if(loopRow) loopRow.hidden = cart.item_count === 0;
    }
    const samples = document.getElementById("CartSamples");
    if(samples) samples.hidden = cart.item_count === 0;
    if(!items) return;
    if(cart.item_count === 0){
      items.innerHTML = '<div class="dr-empty"><b>Nothing in here yet</b>Which is frankly a waste of a good bag.</div>';
      return;
    }
    items.innerHTML = cart.items.map(it => `
      <div class="dr-item">
        <div class="iph">${it.image ? `<img src="${it.image.replace(/(\.[a-z]+)(\?|$)/,"_160x$1$2")}" alt="" loading="lazy">` : ""}</div>
        <div>
          <b>${it.product_title}</b>
          ${it.variant_title && it.variant_title !== "Default Title" ? `<span class="muted">${it.variant_title}</span><br>` : ""}
          <span class="muted">Qty ${it.quantity} · ${money(it.price)} each</span><br>
          <button class="rm" data-remove-key="${it.key}">Remove</button>
        </div>
        <b>${money(it.final_line_price)}</b>
      </div>`).join("");
  }

  async function refreshCart(){
    const r = await fetch("/cart.js"); const cart = await r.json();
    renderCart(cart); return cart;
  }
  window.refreshCart = refreshCart;

  async function addItems(items){
    const r = await fetch("/cart/add.js", {
      method:"POST",
      headers:{ "Content-Type":"application/json", "Accept":"application/json" },
      body: JSON.stringify({ items })
    });
    if(!r.ok){
      const e = await r.json().catch(()=>({}));
      toast(e.description || "Couldn't add that — it may be out of stock");
      /* Shopify may still add what is in stock (for example "Only 1 item was added"), so always show the real bag. */
      await refreshCart();
      if(/added/i.test(e.description || "")) openDrawer();
      return null;
    }
    await refreshCart(); openDrawer(); return r;
  }
  window.addItems = addItems;

  /* quick-add buttons + remove */
  document.addEventListener("click", async e=>{
    const qa = e.target.closest("[data-quick-add]");
    if(qa){
      e.preventDefault();
      qa.disabled = true;
      await addItems([{ id: Number(qa.dataset.quickAdd), quantity: 1 }]);
      qa.disabled = false;
      return;
    }
    const rm = e.target.closest("[data-remove-key]");
    if(rm){
      await fetch("/cart/change.js", {
        method:"POST", headers:{ "Content-Type":"application/json" },
        body: JSON.stringify({ id: rm.dataset.removeKey, quantity: 0 })
      });
      refreshCart();
    }
  });

  /* sample chips — max 2 */
  document.addEventListener("click", e=>{
    const c = e.target.closest(".samplechip"); if(!c) return;
    const on = document.querySelectorAll(".samplechip.on").length;
    if(c.classList.contains("on")) c.classList.remove("on");
    else if(on < 2) c.classList.add("on");
    else toast("Two samples max — the generosity has limits");
  });

  /* ---------- PDP ---------- */
  const pform = document.getElementById("ProductForm");
  if(pform){
    const variants = JSON.parse(document.getElementById("ProductVariants").textContent);
    const idInput = pform.querySelector('input[name="id"]');
    const priceNow = document.getElementById("PriceNow");
    const priceWas = document.getElementById("PriceWas");
    const addBtn = document.getElementById("AddBtn");
    const qtyInput = pform.querySelector('input[name="quantity"]');
    const lowEl = document.getElementById("LowStock");
    let lowStock = {};
    try { lowStock = lowEl ? JSON.parse(lowEl.textContent) : {}; } catch(err) { lowStock = {}; }
    const stockNote = document.getElementById("StockNote");
    const qtyUp = pform.querySelector('[data-qty-change="1"]');
    function currentVariant(){ return variants.find(v => String(v.id) === String(idInput.value)) || variants[0]; }
    function maxFor(v){ return v && lowStock[String(v.id)] ? lowStock[String(v.id)] : null; }
    function syncBuy(){
      const v = currentVariant(); if(!v) return;
      const max = maxFor(v);
      let q = Math.max(1, parseInt(qtyInput.value || "1", 10));
      if(max && q > max){ q = max; toast("Only " + max + " left in stock"); }
      qtyInput.value = q;
      if(max) qtyInput.max = max; else qtyInput.removeAttribute("max");
      if(qtyUp) qtyUp.disabled = !!(max && q >= max);
      if(stockNote){
        stockNote.hidden = !(max && v.available);
        if(max) stockNote.innerHTML = "Only <b>" + max + "</b> left in stock";
      }
      if(priceNow) priceNow.textContent = money(v.price);
      if(priceWas){ priceWas.hidden = !(v.compare_at_price && v.compare_at_price > v.price); if(v.compare_at_price) priceWas.textContent = "RRP " + money(v.compare_at_price); }
      const tm = document.getElementById("TradeMargin");
      if(tm){
        const ok = !!(v.compare_at_price && v.compare_at_price > v.price);
        tm.hidden = !ok;
        if(ok) tm.innerHTML = "Sell at RRP and keep <b>" + money(v.compare_at_price - v.price) + "</b> per unit, a <b>" + Math.floor((v.compare_at_price - v.price) * 100 / v.compare_at_price) + "%</b> margin.";
      }
      if(addBtn){
        addBtn.disabled = false;
        addBtn.textContent = v.available ? ("Add to bag — " + money(v.price * q)) : "Sold out — enquire for ETA";
        addBtn.classList.toggle("is-enquire", !v.available);
      }
      const se = document.getElementById("StockEnquiry");
      if(se && !se.querySelector(".se-done")){
        se.hidden = !!v.available;
        const seOpt = document.getElementById("SeOption"), seSku = document.getElementById("SeSku"), seLink = document.getElementById("SeLink");
        if(seOpt) seOpt.value = v.title === "Default Title" ? "" : v.title;
        if(seSku) seSku.value = v.sku || "";
        if(seLink) seLink.value = location.origin + location.pathname + "?variant=" + v.id;
      }
      const bnpl = document.getElementById("Bnpl");
      if(bnpl) bnpl.innerHTML = "or 4 × <b>" + money(Math.round(v.price/4)) + "</b> with Afterpay / Zip";
      const pour = document.getElementById("PourLine");
      if(pour) pour.innerHTML = "Pours <b>" + Math.round(v.price*q/100) + "mL</b> into your REFILL bottle";
    }
    pform.addEventListener("click", e=>{
      const pill = e.target.closest(".vpill"); if(!pill) return;
      e.preventDefault();
      pform.querySelectorAll(".vpill").forEach(x=>x.classList.remove("on"));
      pill.classList.add("on");
      idInput.value = pill.dataset.variantId;
      const label = document.getElementById("VarLabel");
      if(label) label.textContent = pill.textContent.trim();
      syncBuy();
    });
    document.querySelectorAll("[data-qty-change]").forEach(b=>b.addEventListener("click", ()=>{
      qtyInput.value = Math.max(1, parseInt(qtyInput.value||"1",10) + Number(b.dataset.qtyChange));
      syncBuy();
    }));
    qtyInput.addEventListener("change", syncBuy);
    pform.addEventListener("submit", async e=>{
      e.preventDefault();
      const v = currentVariant(); if(!v) return;
      if(!v.available){
        const se = document.getElementById("StockEnquiry");
        if(se){ se.hidden = false; se.scrollIntoView({behavior:"smooth", block:"center"}); const f = se.querySelector('input[name="contact[name]"]'); if(f) setTimeout(()=>f.focus({preventScroll:true}), 400); }
        return;
      }
      await addItems([{ id: v.id, quantity: Math.max(1, parseInt(qtyInput.value||"1",10)) }]);
    });
    /* gallery */
    document.querySelectorAll(".gthumb").forEach(t=>t.addEventListener("click", ()=>{
      document.querySelectorAll(".gthumb").forEach(x=>x.classList.remove("on"));
      t.classList.add("on");
      const main = document.querySelector(".gmain img");
      if(main && t.dataset.src) main.src = t.dataset.src;
    }));
    syncBuy();
    /* recommendations */
    const reco = document.getElementById("Recommendations");
    if(reco && S.recommendationsUrl){
      fetch(`${S.recommendationsUrl}?product_id=${reco.dataset.productId}&limit=4&section_id=${reco.dataset.sectionId}`)
        .then(r=>r.text()).then(html=>{
          const d = document.createElement("div"); d.innerHTML = html;
          const inner = d.querySelector("#Recommendations");
          if(inner && inner.innerHTML.trim()) reco.innerHTML = inner.innerHTML;
        }).catch(()=>{});
    }
  }

  /* ---------- Hair ID quiz ---------- */
  const quiz = document.getElementById("HairQuiz");
  if(quiz){
    let step = 0;
    const steps = quiz.querySelectorAll(".qstep");
    const dots  = quiz.querySelectorAll(".qdot");
    const result = quiz.querySelector(".qresult");
    const answers = [];
    function show(){
      steps.forEach((s,i)=>s.hidden = i !== step || step >= steps.length);
      dots.forEach((d,i)=>d.classList.toggle("on", i <= Math.min(step, steps.length-1)));
      if(result) result.classList.toggle("on", step >= steps.length);
      const prog = quiz.querySelector(".quiz-progress");
      if(prog) prog.style.visibility = step >= steps.length ? "hidden" : "visible";
    }
    quiz.querySelectorAll(".qopt").forEach(o=>o.addEventListener("click", ()=>{
      o.classList.add("picked");
      answers[step] = o.dataset.value || o.textContent.trim();
      setTimeout(()=>{ step++; show(); quiz.scrollIntoView({behavior:"smooth", block:"start"}); }, 300);
    }));
    const restart = quiz.querySelector("[data-quiz-restart]");
    if(restart) restart.addEventListener("click", ()=>{
      step = 0; answers.length = 0;
      quiz.querySelectorAll(".qopt").forEach(o=>o.classList.remove("picked"));
      show();
    });
    const addAll = quiz.querySelector("[data-quiz-add-all]");
    if(addAll) addAll.addEventListener("click", async ()=>{
      const ids = JSON.parse(addAll.dataset.quizAddAll || "[]").filter(Boolean).map(id=>({id:Number(id), quantity:1}));
      if(ids.length){ await addItems(ids); toast("Routine added — bond first, always"); }
    });
    show();
  }

  /* ---------- account: copy referral code ---------- */
  document.addEventListener("click", e=>{
    const cp = e.target.closest("[data-copy]");
    if(cp){ navigator.clipboard && navigator.clipboard.writeText(cp.dataset.copy); toast("Code copied — go be generous"); }
  });

  /* initial cart state */
  refreshCart();
})();
